import { useState } from 'react';

/**
 * A36（2026-11-03 和田様の UAT）。月の切り替えを親（ドライバー詳細の上部）から受け取る表のページ。
 *
 * 月が変わったら1ページ目に戻す（後ろのページのままだと空になる）。描画の中で戻すので、
 * 前の月のページ番号で新しい月を読む要求は出ない。
 */
export function useMonthPage(month: string): [number, (page: number) => void] {
  const [page, setPage] = useState(1);
  const [pageMonth, setPageMonth] = useState(month);
  if (pageMonth !== month) {
    setPageMonth(month);
    setPage(1);
    return [1, setPage];
  }
  return [page, setPage];
}
